import React, { Fragment } from 'react'
import classnames from 'classnames'
import TasksContainer from '@app/containers/students/Tasks'
import Tasks from '@app/components/students/Tasks'
import Logo from '@app/components/shared/Logo'
import { CompetitionPart } from '@app/components/shared/students/LandingPart'
import ProgressBar from '@app/components/students/ProgressBar'
import BonusTaskOfPreparatory from '@app/containers/students/BonusTaskOfPreparatory'
import { SSOPlatformLink } from '@app/components/ui/buttons/PlatformLink'

const PreparatoryTasks = ({ global, student }) => {
  return (
    <Fragment>
      <div className="student-tasks-page--preparatory">
        <div className="student-tasks-page">
          <div className="student-tasks-page__inner">
            <p className="student-tasks-page__gift hide-mobile">
              {I18n.t('students.preparatory_tour.heading1')}
            </p>

            <div className="hide-mobile">
              <TasksContainer student={student} tour="preparatory" ChildComponent={ProgressBar} />
            </div>

            <div className="student-tasks-page__wrapper">
              <div className="student-tasks-page__description">
                <Logo event={global.event} />
                <div className="student-tasks-page__tour">
                  <div className="student-tasks-page__tour-kind">{ I18n.t('landing.preparatory_round') }</div>
                  <div className="student-tasks-page__class">{ student.participation.olympiad.shortName }</div>
                </div>
                <div className="hide-desktop">
                  <p className="student-tasks-page__gift">
                    {I18n.t('students.preparatory_tour.heading1')}
                  </p>
                  <TasksContainer student={student} tour="preparatory" ChildComponent={ProgressBar} />
                </div>
                <div className="platform">
                  <SSOPlatformLink
                    className="platform__text"
                    linkProps={ { className: "platform__link" } }
                  />
                </div>
              </div>
              <div className="student-tasks-page__tasks">
                <TasksContainer student={student} tour="preparatory" ChildComponent={BonusTaskOfPreparatory} />
                <TasksContainer student={student} tour="preparatory" ChildComponent={Tasks} />
              </div>
            </div>
          </div>
        </div>
      </div>
      <CompetitionPart global={global} student={student} />
    </Fragment>
  )
}

export default PreparatoryTasks
